import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


export const LogoutAam = () => {


    const navigate = useNavigate();

    const logout = async () => {

    localStorage.clear();
    navigate('/loginaam');
    
    };


    useEffect(() => {
        logout();
    }, []);





    return (
        <div>

        </div >
    )
}
